import { TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';

import { TimeClockEntry } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';

export const getBreakSequenceData = (
  breakTimesheetEntry: TimesheetEntry | null,
  timeClockEntry: TimeClockEntry
) => {
  if (breakTimesheetEntry) {
    const { id, baseSequenceId, sequenceId } = breakTimesheetEntry;
    return { id, baseSequenceId, sequenceId };
  }

  return {
    baseSequenceId: timeClockEntry.clockInEntry?.baseSequenceId || null,
  };
};
